import useLocaleObject from '~/composables/useLocaleObject';

export default () => {
  const localeObject = useLocaleObject();

  const { data: requester } = useFetch('/api/requester');
  return computed(() => {
    // if we have the header, then we use it (SSR)
    const { 'cf-ipcountry': countryHeader } = useRequestHeaders([
      'cf-ipcountry',
    ]);

    if (countryHeader != null) {
      return countryHeader;
    }

    // if CSR, then we use the value from the /api/register request and fallback to locale country
    return (
      requester.value?.country ||
      localeObject.value.iso.split('-')[1]?.toUpperCase() ||
      ''
    );
  });
};
